// ************
// Recipe Single View
// Kochmodus Button
// leads to /rezept/id/cooking-mode page
// ************
import { Button } from "@/components/Global/Button/Button";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { useRouter } from "next/router";
import React from "react";

function CookingModeButton() {
  const router = useRouter();
  const { getLabel } = useGlobalContext();

  const recipeId = router.query.id;

  return (
    <Button
      type="primary"
      href="#"
      target={""}
      onClick={() => {
        router.push("/rezepte/" + recipeId + "/kochmodus");
      }}
      icon={"circleCookingMode"}
    >
      {getLabel("cooking_mode")}
    </Button>
  );
}

export default CookingModeButton;
